export default "__VITE_ASSET__CAqWiFh6__"